/**
 * @param   {object}   state
 * @param   {number}   id
 *
 * @returns {Function}
 */
const getDetailById = state => id =>
  state.details.find(detail => detail.id === id)

/**
 * @param   {object}   state
 * @param   {number}   id
 *
 * @returns {Function}
 */
const getDetailsByStyleId = state => id =>
  state.details
    .filter(detail => detail.style_id === id)
    .sort((detail1, detail2) => detail1.index - detail2.index)

/**
 * @type {object}
 */
const getters = {
  getDetailById,
  getDetailsByStyleId
}

export default getters
